
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/privacy/page";
import TermsOfService from "../pages/terms/page";
import InvitePage from "../pages/invite/page";
import PartnerLandingPage from "../pages/partner/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/invite/:code",
    element: <InvitePage />,
  },
  {
    path: "/partner/:partnerId",
    element: <PartnerLandingPage />,
  },
  {
    path: "/partner/:partnerId/:eventId",
    element: <PartnerLandingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
